import React from "react";
import { StoryElement } from "@quintype/components";
import PropTypes from "prop-types";

import { CloseIcon } from "../../basic/icons/close-icon";
import "./light-box.m.css";

class LightBox extends React.Component {
  render() {
    return (
      <div styleName="lightbox-wrapper">
        <div styleName="lightbox">
          <figure>
            <StoryElement element={this.props.element} />
          </figure>
          <button onClick={this.props.closePopup} styleName="icon-close">
            <CloseIcon color="#1C1C1C" />
          </button>
        </div>
      </div>
    );
  }
}

LightBox.propTypes = {
  element: PropTypes.object,
  closePopup: PropTypes.func
};

export { LightBox };
